
export const Booleans = [
  {"k":"1","v":"あり"},
  {"k":"0","v":"なし"},
];

/**---------------------------------------------
 * selectOptions 関数の説明
 * セレクトボックスの汎用コンポーネント
**-----------------------------------------------*/
export const selectOptions = (name,obj,value="",disabled=``) =>{
  if(typeof obj != 'object'){
    return ``
  }else{
    return`
    <div class="select">
      <select name="${name}" ${disabled}>
        ${obj.map(v=>{
          v.k=v.k==null?v.key:v.k;
          v.v=v.v==null?v.value:v.v;
          const S = v.k==value?' selected':'';
          return`<option value="${v.k}"${S}>${v.v}</option>`
        }).join('')}
      </select>
    </div>
    `;
  }
}

/**---------------------------------------------
 * selectOptions 関数の説明
 * セレクトボックスの汎用コンポーネント
**-----------------------------------------------*/
export const selectOptionsNormal = (name,obj,value="",disabled=``) =>{
  if(typeof obj != 'object'){
    return ``
  }else{
    return`
      <select name="${name}" ${disabled}>
        ${obj.map(v=>{
          v.k=v.k==null?v.key:v.k;
          v.v=v.v==null?v.value:v.v;
          const S = v.k==value?' selected':'';
          return`<option value="${v.k}"${S}>${v.v}</option>`
        }).join('')}
      </select>
    `;
  }
}


/**---------------------------------------------
 * セレクトボックスのキーを取得し、objで値を取得し、
 * inputに値をセットする
 * usage
 * setInputFromSelect(`[name="agent_ID"]`,`[name="AGT_description"]`,desctioptions);
**-----------------------------------------------*/
export const setInputFromSelect = (selectbox,input,obj) =>{
  const selectBox = document.querySelector(selectbox);
  const inputBox = document.querySelector(input);
  const key = selectBox.value;
  const value = obj[key];
  inputBox.value = value;
}



/**---------------------------------------------
 * Options 関数の説明
 * オプションの汎用コンポーネント
**-----------------------------------------------*/
export const Options = (arr,value="") =>{
  if(Array.isArray(arr)){
    return `${arr.map(v=>{
      v.k=v.k==null?v.key:v.k;
      v.v=v.v==null?v.value:v.v;
      const S = v.k==value?' selected':'';
      return`<option value="${v.k}"${S}>${v.v}</option>`
    }).join('')}
    `;
  }else{
    console.log(arr,`object error!!`);
    return ``;
  }

}

/**---------------------------------------------
 * inputRadios 関数の説明
 * ラジオボタンの汎用コンポーネント
**-----------------------------------------------*/
export const inputRadios = (name,obj,value="",br=false) =>{
  let breaking;
  if(br==true){
    breaking = '<br>';
  }else{
    breaking = '';
  }
  if(typeof obj != 'object'){
    return ``
  }else{
    return obj.map(v=>{
      const C = v.k==value?' checked':'';
      return`<label class="radio"><input type="radio" name="${name}" value="${v.k}"${C}>${v.v}</label>${breaking}`
    }).join('');
  }
}

/**---------------------------------------------
 * inputCheckboxes 関数の説明
 * チェックボックスの汎用コンポーネント
**-----------------------------------------------*/
export const inputCheckboxes = (name,obj,values,br=false) =>{
  const breaking = br==true?`<br>`:``;
  if(typeof obj != 'object'){
    return ``
  }else{
    return obj.map(v=>{
      const C = values.includes(v.k)?`checked`:``;
      return`<label class="checkbox"><input type="checkbox" name="${name}" value="${v.k}"${C}> ${v.v}</label>${breaking}`
    }).join('');
  }
}

// 時間選択用 配列作成
export const times = (start=8,end=19,per=30) =>{
  let dt = dayjs("2022-01-01 00:00").add(start,'hours');
  let finish = dayjs("2022-01-01 00:00").add(end,'hours');
  let time = dt.format('HH:mm');
  const times = [];
  while (true) {
    const data = {"k":time,"v":time}
    times.push(data);
    time = dt.add(per,'minutes').format('HH:mm');
    dt = dt.add(per,'minutes');
    if(dt.isAfter(finish)==true){
      break;
    }
  }
  return times;
}

/**---------------------------------------------
 * toWeireki 関数の説明
 * 西暦を和暦を算出
 * 日付チェック含む
**-----------------------------------------------*/
export const toWareki = (dateString) => {
  const dt = Date.parse(`${dateString} 00:00:00`);
  console.log(dateString);
  if(dateString=="0000-00-00"){
    return false;
  }

//  const dt = dayjs(dateString).unix()*1000;
  const date =  new Intl.DateTimeFormat(
    'ja-JP-u-ca-japanese', {
        era:'long',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
  ).format(dt);


  const regex = /^([^\d]+)(\d+)\/(\d+)\/(\d+)$/;
  const match = date.match(regex);
  if (match) {
    let [_, era, year, month, day] = match;
    //console.log(`${era}${year}`);
    if(era=='明治'||era=='大正'){
      year = parseInt(year);
    }
    const result = [era, year, month, day];
    return result;
  } else {
    console.log('Invalid date string.');

  }
}

/**---------------------------------------------
 * convertWarekiToSeireki 関数の説明
 * 和暦から西暦を算出
**-----------------------------------------------*/
export function convertWarekiToSeireki(era, year) {
  const gengo = {
    "令和": 2018,
    "平成": 1988,
    "昭和": 1925,
    "大正": 1911,
    "明治": 1867
  };

  const gengoYear = parseInt(year, 10);
  const seirekiYear = gengo[era] + gengoYear;

  return seirekiYear;
}


/**---------------------------------------------
 * selectWareki 関数の説明
**-----------------------------------------------*/
export const selectWareki = (name,dateString="1981-12-23") =>{
  //console.log(dateString);
  const wareki = toWareki(dateString);
  const gengo = [
    {"k":"明治","v":"明治"},
    {"k":"大正","v":"大正"},
    {"k":"昭和","v":"昭和"},
    {"k":"平成","v":"平成"},
    {"k":"令和","v":"令和"}
  ];
  //console.log(wareki);

  return`
  <div class="select">
    <select name="${name}[gengo]">
      ${gengo.map(v=>{
        const S = v.k==wareki[0]?' selected':'';
        return`<option value="${v.k}"${S}>${v.v}</option>`
      }).join('')}
    </select>
  </div>
  <input class="input" type="number" name="${name}[year]" value="${wareki[1]}">年
  <input class="input" type="number" name="${name}[month]" value="${wareki[2]}">月
  <input class="input" type="number" name="${name}[day]" value="${wareki[3]}">日<br>

        <p class="is-size-6 has-text-info">${wareki[0]}${wareki[1]}年は西暦${convertWarekiToSeireki(wareki[0],wareki[1])}年です</p>
  `;
}



/**---------------------------------------------
 * postalFormat 関数の説明
 * 3文字目と4文字目の間にハイフンをつける
 * ハイフンがすでについていればそのまま返す
 * 用途：郵便番号格納時
**-----------------------------------------------*/
export const postalFormat = (postalCode) =>{
  const regex = /^(.{3}\-.{4})$/;
  if (regex.test(postalCode)) {
    return postalCode;
  }


  const start_num = postalCode.substr(0,3);
  const end_num = postalCode.substr(3);
  const num_code =  start_num + '-' + end_num;
  return num_code
}

/**---------------------------------------------
 * removeCommasAndConvertToNumber 関数の説明
 * 文字列からカンマを取り除いて数値に変換
 * 用途：数字の入力フォーム
**-----------------------------------------------*/
export const removeCommasAndConvertToNumber = (inputString) => {
  // 数字とカンマ以外の文字が含まれているかチェック
  const regex = /[^0-9,-]/;
  if (regex.test(inputString)) {
    console.log(inputString);
    alert(`数字とカンマ、『-』以外の文字が含まれています。`);
    return null;
  }
  // カンマを取り除いて文字列を数値に変換
  const withoutCommas = inputString.replace(/,/g, "");
  const result = Number(withoutCommas);
  return result;
}

/**---------------------------------------------
 * extractNumbers関数の説明
 * 文字列から数字のみを抽出して連結
 * usage
 * const inputString = "abc123def456ghi789";
 * const result = extractNumbers(inputString);
**-----------------------------------------------*/
export const extractNumbers = (input) => {
  // 正規表現で数字のみを抽出
  const numbers = input.match(/\d+/g);
  // 抽出された数字を連結して返す
  return numbers ? numbers.join('') : '';
}


/**---------------------------------------------
 * NavFilter 関数の説明
 * トグルメニューの生成用コンポーネント
 * 用途：ページ内メニュー作成時
**-----------------------------------------------*/
export const NavFilter = (navs,target) => {
  return`
  <nav class="tabs is-toggle is-fullwidth pt-5">
    <ul>
      ${navs.map(v=>{
        const active = v.k==target?` class="is-active"`:"";
        return `<li${active}><a href="${v.url}">${v.v}</a></li>`;
      }).join('')}

    </ul>
</nav>
`;
}

export const nl2br = (str) => {
  return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
}

/**---------------------------------------------
 * getElementalStyles
 * 要素に適用されているCSS情報をすべて取得する
 * 用途：印刷用レイアウトの動的調整時
 * const styles = getElementalStyles(`section.section`);
**-----------------------------------------------*/
export const getElementStyles = (el) => {
  const result = {
    "element":el
  };
  const element = document.querySelector(el);
  if(!element){return result}

  result["height"] = element.clientHeight;
  result["width"] = element.clientWidth;

  const computedStyles = window.getComputedStyle(element);
  // スタイルオブジェクトの各プロパティと値を格納
  for (const propertyName of computedStyles) {
    const propertyValue = computedStyles.getPropertyValue(propertyName);
    result[propertyName] = parseInt(propertyValue.replace('px', ''));
  }
  return result;
}

/**---------------------------------------------
 * LoadingOn Loadingoff関数の説明
 * オーバーレイでローディングアニメーションを表示する
 * 用途：通信時
**-----------------------------------------------*/

export const LoadingOn = () =>{
  const loading = `<div id="modal-loading" class="modal modal-fx-fadeInScale is-active">
    <div class="modal-background"></div>
    <div class="loading01 is-loading-img is-size-1 is-primary">
      <div></div>
      <div></div>
    </div>
  </div>`;
  document.body.insertAdjacentHTML('beforeend',loading);

  // const modal = document.getElementById(`modal-loading`);
  // modal.classList.add(`is-active`);
}
export const LoadingOff = () =>{
  const loading = document.getElementById(`modal-loading`);
  loading.remove();
  // const modal = document.getElementById(`modal-loading`);
  // modal.classList.remove(`is-active`);
}

/**---------------------------------------------
 * limitCheckboxSelection関数の説明
 * 指定された数までチェックされたらdisabledにする
 * 用途：受付可能寄贈品
**-----------------------------------------------*/
export const limitCheckboxSelection = (selector, max) =>{
  const checkboxes = document.querySelectorAll(selector);
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const checked = document.querySelectorAll(`${selector}:checked`);
      if (checked.length >= max) {
        checkboxes.forEach((cb) => {
          if (!cb.checked) {
            cb.disabled = true;
          }
        });
      } else {
        checkboxes.forEach((cb) => {
          cb.disabled = false;
        });
      }
    });
  });

  // ページが読み込まれたときの初期化処理
  const checked = document.querySelectorAll(`${selector}:checked`);
  if (checked.length >= max) {
    checkboxes.forEach((cb) => {
      if (!cb.checked) {
        cb.disabled = true;
      }
    });
  }
}

//kーを渡すとvを返す
export const getValueByKey = (obj, key) => {
  for (let i = 0; i < obj.length; i++) {
    if (obj[i].k === key) {
      return obj[i].v;
    }
  }
  return null; // キーに対応する値が見つからなかった場合はnullを返す
}

  /**---------------------------------------------
   * getCheckboxValues 関数の説明
   * 同じname属性の複数のcheckboxから、
   * チェックがオンのcheckboxのvalueを配列にして取得
   * const PTP_slugs = getCheckboxValues(`PTP_slugs`);
  **-----------------------------------------------*/
  export const getCheckboxValues = (name) => {
    const checkboxes = document.getElementsByName(name);
    return Array.from(checkboxes)
    .filter(checkbox => checkbox.checked)
    .map(checkbox => checkbox.value);
  }


  /**---------------------------------------------
   * checkAllCheckbox関数の説明
   * 指定したボタンをクリックすると、
   * 指定したセレクタのチェックボックスをすべてONにする
   * すべてONの場合はすべてOFFにする
   * usage
   * checkAllCheckbox('#myButton', '.myCheckboxes');
  **-----------------------------------------------*/
  export const checkAllCheckbox = (buttonSelector,checkboxesSelector) => {
    const button = document.querySelector(buttonSelector);
    const checkboxes = document.querySelectorAll(checkboxesSelector);

    button.addEventListener('click', () => {
        const areAllChecked = Array.from(checkboxes).every(checkbox => checkbox.checked);
        checkboxes.forEach(checkbox => checkbox.checked = !areAllChecked);
    });
  }


  export const StandbysCheckbox = (STBs,plus,selector) => {
    const num = typeof plus == 'number'?plus:parseInt(plus);
    const date = dayjs().add(parseInt(plus), 'd').format('YYYY-MM-DD');
    //objectからowner_IDプロパティのみを抽出した配列を作成
    const owner_IDs = STBs[date].standbys.map(v => v.owner_ID);
    console.log(owner_IDs);
    //name="selector"のチェックボックスで、owner_IDsに含まれるowner_IDをvalueに持つものをチェックする
    const checkboxes = document.querySelectorAll(`input[name="${selector}"]`);
    checkboxes.forEach((checkbox) => {
      if (owner_IDs.includes(checkbox.value)) {
        checkbox.checked = true;
      }
    });
  };
/**---------------------------------------------
 * adjustFontSize関数の説明
 *
 * 指定したNodeの中身のテキストを調べて、
 * 一番長いテキストの行の幅に合わせてフォントサイズを調整する
 * usage
 *  const textNode = v.querySelector('span.gaiji')
 *  adjustFontSize(textNode, settingWidth);
 * ※注意：textNodeはインライン要素であること。
 * ブロック要素だと幅が100%になってしまい、テキストの幅が取得できない為。
**-----------------------------------------------*/
export const adjustFontSize = (textNode, settingWidth,isLog=false) => {
  //textNodeを折り返し禁止にして、はみ出して表示させる
  //textNodeがtdかどうかを調べる
  if(textNode.tagName=="TD"||textNode.tagName=="TH"){
    textNode.style.whiteSpace = 'nowrap';
    textNode.style.overflow = 'visible';
  }
  const width = textNode.offsetWidth;
  //現在のフォントサイズを取得
  let maxFontSize = window.getComputedStyle(textNode, null).getPropertyValue('font-size');
  maxFontSize = parseInt(maxFontSize.replace('px', ''));
  console.log(`maxFontSize`,maxFontSize);
  //if(isLog==true)console.log(textNode,`width:`,width,`settingWidth:`,settingWidth);
  if(width>settingWidth){
    const textArray = textNode.innerHTML.split('<br>');
    const textLength = textArray.map(v => v.length);
    const maxTextLength = Math.max(...textLength);
    //serringWidth / maxTextLengthで小数点以下を切り捨てる
    let fontSize = Math.floor(settingWidth / maxTextLength);
    if(maxFontSize<fontSize){
      fontSize = maxFontSize;
    }
    console.log(`fontSize`,fontSize);
    textNode.style.fontSize = `${fontSize}px`;
    if(isLog==true)console.log(textNode,`settingWidth:`,settingWidth,`fontSize:`,fontSize);
  }
}
/**---------------------------------------------
 * HTMLのformタグ内のデータをJSONフォーマットに変換する
 * usage
 * const form = document.getElementById('myForm');
 * const jsonData = formToJson(form);
**-----------------------------------------------*/
export const formToJson = (formId) => {
  const form = document.getElementById(formId);
  const formData = new FormData(form);
  const jsonData = {};
  formData.forEach((value, key) => {
      const keys = key.split('[').map(part => part.replace(']', ''));
      let current = jsonData;
      for (let i = 0; i < keys.length - 1; i++) {
          current = current[keys[i]] = current[keys[i]] || {};
      }
      current[keys[keys.length - 1]] = value;
  });
  return jsonData;
}

/**---------------------------------------------
 * adjustInputWidth関数の説明
 * usage
 * const node = document.getElementById('myInput');
 * adjustInputWidth(node);
**-----------------------------------------------*/
export const adjustInputWidth = (node) => {
  // nodeのmaxlengthを取得
  const maxLength = node.getAttribute('maxlength');
  // もしmaxlengthがない場合は終了
  if (!maxLength) return;
  // maxlengthを数値に変換
  const maxLengthNumber = parseInt(maxLength, 10);
  // nodeに適用されているfontsizeを取得
  const fontSize = window.getComputedStyle(node, null).getPropertyValue('font-size');
  // fontsizeを数値に変換
  const fontSizeNumber = parseFloat(fontSize);
  //入力されている値に全角文字があるかどうかを判定
  const isZenkaku = (str) => {
    return (str.length !== str.replace(/[^\x01-\x7E\xA1-\xDF]/g, '').length);
  }
  if(!isZenkaku(node.value)){
    node.style.width = `${18 + (maxLengthNumber * fontSizeNumber * 0.6)}px`;
  }else{
    node.style.width = `${18 + (maxLengthNumber * fontSizeNumber)}px`;
  }
}
/**---------------------------------------------
 * adjustInputWidth関数の説明
 * usage
 * const node = document.getElementById('myInput');
 * focusInput(node);
**-----------------------------------------------*/
export const focusInput = (node) => {
  // もしノードvalueが数字のみではなければ終了
  if (/^\d+$/.test(node.value)){
    node.value = removeCommasAndConvertToNumber(node.value).toLocaleString();
  }

  node.addEventListener('focusout', function(){
    if (!/^\d+$/.test(node.value)) return;
      node.value = removeCommasAndConvertToNumber(node.value).toLocaleString();
  })
  // フォーカス時にカンマを削除して数値に変換
  node.addEventListener('focus', function(){
    if (!/^\d+$/.test(node.value)){
      node.select();
      return;
    }
    node.value = removeCommasAndConvertToNumber(node.value);

  })
}

/**---------------------------------------------
 * ハイフンありの電話番号
**-----------------------------------------------*/
export const isPhoneNumber = (str) => {
  let pattern = /^\d{2,4}-\d{2,4}-\d{3,4}$/;
  return pattern.test(str);
}


/**---------------------------------------------
 * rgbToHex関数の説明
 * RGB値を16進数のカラーコードに変換する
 * usage
 * const hexColor = rgbToHex('rgb(255, 255, 255)');
**-----------------------------------------------*/
export const rgbToHex = (rgb) => {
  if(rgb==null||rgb==""){
    return false;
  }
  // 正規表現を使用してRGB値を抽出
  const result = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);

  if (result) {
      // 各RGB値を16進数に変換
      const r = parseInt(result[1]).toString(16).padStart(2, '0');
      const g = parseInt(result[2]).toString(16).padStart(2, '0');
      const b = parseInt(result[3]).toString(16).padStart(2, '0');

      // #xxxxxx形式の文字列を返す
      return `#${r}${g}${b}`;
  } else {
      console.log("Invalid RGB format");
      return false;
      throw new Error("Invalid RGB format");
  }
}
/**---------------------------------------------
 * 色の判定関数
 * ■第2引数の基準値を1に近づけると文字色を白色に寄せる
 * ■第2引数の基準値を5に近づけると文字色を黒色に寄せる
 *
 * 背景色によって文字色を白か黒で返す。
 * 見やすさの基準は「コントラスト比」に基づいて判断する。
 * コントラスト比とは、背景色と文字色の輝度差を数値化したもので、この値が大きいほど視認性が高くなる。
 * ここでの「見やすさの基準」は、指定された基準値に基づいてコントラスト比を判断する。
 * 基準は1から5まで指定でき、標準は3とする。
 * この基準に基づいて背景色に対する最適な文字色（白または黒）を返します。
 *
 * コントラスト比の計算には以下の公式を使用する：
 * コントラスト比　= (明るい色の相対輝度 + 0.05) / (暗い色の相対輝度 + 0.05)
 * 相対輝度 L は次のように計算する：
 * L=0.2126*R+0.7152*G+0.0722*B
 * ここで、R、G、B はRGB値を0から1に正規化したもの。
**-----------------------------------------------*/
export const getReadableTextColor = (bgColor, contrastLevel = 3) => {
  if(bgColor==null||bgColor==""){
    return false;
  }

  // RGB値を取得
  let r = parseInt(bgColor.substr(1, 2), 16) / 255;
  let g = parseInt(bgColor.substr(3, 2), 16) / 255;
  let b = parseInt(bgColor.substr(5, 2), 16) / 255;

  // 相対輝度を計算
  let luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // コントラスト比の基準値
  const contrastThresholds = {
    1: 1.25,
    2: 1.5,
    3: 2.0,
    4: 2.5,
    5: 3.0
  };
  let threshold = contrastThresholds[contrastLevel] !== undefined ? contrastThresholds[contrastLevel] : 2.0;
  // 白と黒の相対輝度
  const whiteLuminance = 1.0;
  const blackLuminance = 0.0;
  // 白と黒のコントラスト比を計算
  let contrastWithWhite = (whiteLuminance + 0.05) / (luminance + 0.05);
  let contrastWithBlack = (luminance + 0.05) / (blackLuminance + 0.05);
  // 最適な文字色を返す
  if (contrastWithWhite >= threshold) {
    return '#FFFFFF'; // 白
  } else if (contrastWithBlack >= threshold) {
    return '#000000'; // 黒
  } else {
    // 基準値を満たさない場合は黒をデフォルトに
    return '#000000'; // 黒
  }
}

export const backgroundTextColor = (element,level) => {
  const bgColor = rgbToHex(window.getComputedStyle(element).backgroundColor);
  const textColor = getReadableTextColor(bgColor);
  element.style.color = textColor;
  return textColor;
}

/**---------------------------------------------
 * オブジェクト配列から指定した「プロパティ名=値」を持つ要素のインデックスを取得する
 * 複数ある場合は最初に見つかったインデックスを返す
 * 見つからなかった場合は-1を返す
 * usage
 * const array = [{id: 1, name: 'apple'}, {id: 2, name: 'banana'}, {id: 3, name: 'apple'}];
 * const index = findIndexByProperty(array, 'id', 3);
 * console.log(index); // 2
**-----------------------------------------------*/
export const findIndexByProperty = (array, property, value) => {
  for (let i = 0; i < array.length; i++) {
      if (array[i][property] === value) {
          return i;
      }
  }
  return -1; // 見つからなかった場合
}
/**---------------------------------------------
 * オブジェクト配列から指定したproperty=valueを持つ要素を抽出して返す
 * usage
 * const array = [{id: 1, name: 'apple'}, {id: 2, name: 'banana'}, {id: 3, name: 'apple'}];
 * const newArray = arrayFilter(array, 'name', 'apple');
 * console.log(newArray); // [{id: 1, name: 'apple'}, {id: 3, name: 'apple'}]
**-----------------------------------------------*/
export const arrayFilter = (array, property,value) => {
  return array.filter(item => item[property] === value);
};
/**---------------------------------------------
 * オブジェクト配列を特定のプロパティでソートする
 * usage
 * const array = [{id: 3, name: 'apple'}, {id: 1, name: 'banana'}, {id: 2, name: 'apple'}];
 * const sortedArray = sortByProperty(array, 'id');
 * console.log(sortedArray); // [{id: 1, name: 'banana'}, {id: 2, name: 'apple'}, {id: 3, name: 'apple'}]
**-----------------------------------------------*/
export const sortByProperty = (array, property) => {
  return array.sort((a, b) => a[property] - b[property]);
}
/**---------------------------------------------
 * オブジェクト配列を特定のプロパティの値を配列として取得する
 * usage
 * const array = [{id: 1, name: 'apple'}, {id: 2, name: 'banana'}, {id: 3, name: 'apple'}];
 * const values = getPropertyValues(array, 'name');
 * console.log(values); // ['apple', 'banana', 'apple']
**-----------------------------------------------*/
export const getPropertyValues = (array, property) => {
  return array.map(item => item[property]);
}

/**---------------------------------------------
 * オブジェクト配列で、特定のプロパティに基づいてグループ化する
 * usage
 * const array = [{id: 1, name: 'apple'}, {id: 2, name: 'banana'}, {id: 3, name: 'apple'}];
 * const grouped = groupByProperty(array, 'name');
 * console.log(grouped);
 * // {
 * //   apple: [{id: 1, name: 'apple'}, {id: 3, name: 'apple'}],
 * //   banana: [{id: 2, name: 'banana'}]
 * // }
**-----------------------------------------------*/
export const groupByProperty = (array, property) => {
  return array.reduce((result, item) => {
    (result[item[property]] = result[item[property]] || []).push(item);
    return result;
  }, {});
}
/**---------------------------------------------
 * オブジェクト配列で、特定のプロパティ名をリネームする
 * usage
 * const array = [{id: 1, name: 'apple'}, {id: 2, name: 'banana'}, {id: 3, name: 'apple'}];
 * const renamedArray = renameProperty(array, 'name', 'fruit');
 * console.log(renamedArray);
 * // [{id: 1, fruit: 'apple'}, {id: 2, fruit: 'banana'}, {id: 3, fruit: 'apple'}]
**-----------------------------------------------*/
export const renameProperty = (array, oldProperty, newProperty) => {
  return array.map(item => {
    return {
      ...item,
      [newProperty]: item[oldProperty],
    };
  });
}
/**---------------------------------------------
 * 多次元オブジェクトを、配列に変換し、特定のプロパティでソートする
 * usage
 * const object = {
 *  1: {id: 1, name: 'apple'},
 *  2: {id: 2, name: 'banana'},
 *  3: {id: 3, name: 'apple'}
 * };
 * const sortedArray = sortObjectByProperty(object, 'id');
 * console.log(sortedArray);
 * // [{id: 1, name: 'apple'}, {id: 2, name: 'banana'}, {id: 3, name: 'apple'}]
**-----------------------------------------------*/
export const sortObjectByProperty = (object, property) => {
  return Object.values(object).sort((a, b) => a[property] - b[property]);
}
/**---------------------------------------------
 * オブジェクト配列を、指定したプロパティをキーにした多次元オブジェクトに変換する
 * usage
 * const array = [{id: 1, name: 'apple'}, {id: 2, name: 'banana'}, {id: 3, name: 'apple'}];
 * const object = arrayToObject(array, 'id');
 * console.log(object);
 * // {
 * //   1: {id: 1, name: 'apple'},
 * //   2: {id: 2, name: 'banana'},
 * //   3: {id: 3, name: 'apple'}
 * // }
**-----------------------------------------------*/
export const arrayToObject = (array, key) => {
  return array.reduce((result, item) => {
    result[item[key]] = item;
    return result;
  }, {});
}
/**---------------------------------------------
 * 配列で指定した要素を削除する
 * usage
 * let myArray = [1, 2, 3, 4, 5];
 * console.log(removeElement(myArray, 3)); // [1, 2, 4, 5]
**-----------------------------------------------*/
export const removeElement = (array, value) =>{
  const index = array.indexOf(value);
  if (index !== -1) {
      array.splice(index, 1);
  }
  return array;

}

/**---------------------------------------------
 * 配列で指定したインデックスより前の要素を削除して詰める
 * usage
 * let array = [1, 2, 3, 4, 5, 6];
 * let index = 3;
 * let newArray = removeElementsBeforeIndex(array, index);
 * console.log(newArray); // [4, 5, 6]
**-----------------------------------------------*/
export const removeElementsBeforeIndex = (array, index) => {
  // インデックスが配列の範囲内か確認
  if (index < 0 || index >= array.length) {
      throw new Error("Index out of bounds");
  }

  // インデックスより前の要素を削除
  return array.slice(index);
}
/**---------------------------------------------
 * 配列の要素をランダムに並び替える
 * usage
 * const array = [1, 2, 3, 4, 5];
 * const shuffledArray = shuffleArray(array);
 * console.log(shuffledArray); // [3, 1, 5, 4, 2]
**-----------------------------------------------*/
export const shuffleArray = (array) =>{
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}
/**---------------------------------------------
 * 配列のユニークな要素のみを含む新しい配列を返す
 * usage
 * const array = [1, 2, 2, 3, 4, 4, 5];
 * const uniqueArray = getUniqueElements(array);
 * console.log(uniqueArray); // [1, 2, 3, 4, 5]
**-----------------------------------------------*/
export const getUniqueElements = (array) => {
  return [...new Set(array)];
}
/**---------------------------------------------
 * 配列の数値の合計を計算して返す
 * usage
 * const array = [1, 2, 3, 4, 5];
 * const sum = sumArray(array);
 * console.log(sum); // 15
**-----------------------------------------------*/
export const sumArray = (array) => {
  return array.reduce((acc, current) => acc + current, 0);
}
/**---------------------------------------------
 * オブジェクト配列で特定のプロパティの値の合計を計算して返す
 * usage
 * const array = [{id: 1, value: 100}, {id: 2, value: 200}, {id: 3, value: 300}];
 * const sum = sumPropertyValues(array, 'value');
 * console.log(sum); // 600
**-----------------------------------------------*/
export const sumPropertyValues = (array, property) => {
  return array.reduce((acc, current) => acc + current[property], 0);
}
/**---------------------------------------------
 * 配列を指定したサイズに分割する
 * usage
 * const array = [1, 2, 3, 4, 5, 6, 7, 8, 9];
 * const chunkedArray = chunkArray(array, 3);
 * console.log(chunkedArray); // [[1, 2, 3], [4, 5, 6], [7, 8, 9]]
**-----------------------------------------------*/
export const chunkArray = (array, size) => {
  return array.reduce((acc, _, i) => (i % size ? acc : [...acc, array.slice(i, i + size)]), []);
}
/**---------------------------------------------
 * お問い合わせのバリデーションスキーマ
 * デフォルト値
**-----------------------------------------------*/
export const InquirySchema = {
    type: "object",
    properties: {
      sei_kj: {
        type: "string",
        minLength: 1,
        maxLength: 20,
        hasUpperLowerCase: true,
        errorMessage: {
          type: "『姓』は文字列である必要があります",
          minLength: "『姓』は2文字以上である必要があります",
          maxLength: "『姓』は20文字以下である必要があります",
        }
      },
      mei_kj: {
        type: "string",
        minLength: 1,
        maxLength: 20,
        hasUpperLowerCase: true,
        errorMessage: {
          type: "『名』は文字列である必要があります",
          minLength: "『名』は2文字以上である必要があります",
          maxLength: "『名』は20文字以下である必要があります",
        }
      },
      sei_kn: {
        type: "string",
        minLength: 1,
        maxLength: 20,
        hasUpperLowerCase: true,
        errorMessage: {
          type: "『せい』は文字列である必要があります",
          minLength: "『せい』は2文字以上である必要があります",
          maxLength: "『せい』は20文字以下である必要があります",
        }
      },
      mei_kn: {
        type: "string",
        minLength: 1,
        maxLength: 20,
        hasUpperLowerCase: true,
        errorMessage: {
          type: "『めい』は文字列である必要があります",
          minLength: "『めい』は2文字以上である必要があります",
          maxLength: "『めい』は20文字以下である必要があります",
        }
      },
      email: {
        type: "string",
        format: "email",
        errorMessage: {
          type: "メールアドレスは文字列である必要があります",
          format: "有効なメールアドレス形式である必要があります"
        }
      },
      phone: {
        type: "string",
        pattern: "^0\\d{1,3}-\\d{1,4}-\\d{3,4}$", // ハイフンが２つ、数字が11文字以内
        errorMessage: {
          type: "電話番号は文字列である必要があります",
          pattern: "有効な電話番号形式である必要があります"
        }
      }
    },
    required: ["sei_kj","mei_kj","sei_kn","mei_kn", "email", "phone"],
    errorMessage: {
      required: {
        sei_kj: "『姓』は必須項目です",
        mei_kj: "『名』は必須項目です",
        sei_kn: "『せい』は必須項目です",
        mei_kn: "『めい』は必須項目です",
        email: "メールアドレスは必須項目です",
        phone: "電話番号は必須項目です"
      }
    }
  };
